<script lang="ts">
	import type { SbVideo } from '../types';
	import Video from '$lib/video.svelte';
	import BtnIcon from '$lib/buttons/v2/btnIcon.svelte';
	import Pause from '$lib/icons/pause.svelte';
	import { scale } from 'svelte/transition';
	import Play from '$lib/icons/play.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		content: ISbStoryData<{
			video: SbVideo[];
			video_desktop: SbVideo[];
			show_overlay: boolean;
			hide_play_button: boolean;
		}>['content'];
	}

	let { content }: Props = $props();

	let paused = $state(false);

	let video = $derived(device.data.isDesktop ? content.video_desktop[0] : content.video[0]);
</script>

<Video
	autoplay={video.autoplay ? (video.mute ? 'muted' : 'any') : null}
	loop={video.loop}
	muted
	wrapperClass="h-full w-full"
	class="h-full w-full object-cover"
	playbackId={video.playback_id}
>
	{#snippet children(videoElement, loaded)}
		<div class="pointer-events-none absolute inset-0" class:overlay={content.show_overlay}></div>
		{#if loaded && !content.hide_play_button}
			<div class="pointer-events-auto absolute bottom-0 left-0 lg:m-5" in:scale>
				<BtnIcon
					title="Pause video"
					theme="transparent/stone/green"
					onclick={() => {
						if (!videoElement) return;

						if (videoElement.paused) {
							videoElement.play();
							paused = false;
						} else {
							videoElement.pause();
							paused = true;
						}
					}}
					>{#if paused}<Play class="h-5 w-5" />{:else}<Pause class="h-5 w-5" />{/if}</BtnIcon
				>
			</div>
		{/if}
	{/snippet}
</Video>

<style>
	div.overlay {
		background: linear-gradient(180deg, rgba(36, 13, 2, 0) 0%, #250e02 100%);
	}
</style>
